import '../../sass/form/index.scss';
import 'select2/dist/css/select2.css';
import 'daterangepicker/daterangepicker.css';
import 'react-day-picker/lib/style.css';
import 'react-tippy/dist/tippy.css';
import installGlobalErrorReporter from '@common/helpers/installGlobalErrorReporter';
import cookieStorage from '@common/helpers/cookieStorage';

installGlobalErrorReporter('v5-form');

if (cookieStorage.get('nightMode') === '1') {
    document.body.classList.add('dark');
}

import React from "react";
import {render} from "react-dom";
import {Provider} from "react-redux";
import Index from "./components/Index";
import configureStore from "../core/reducers/configureStore";
import OrderOptionsReducer from "./reducers/OrderOptionsReducer";
import AuthOptionsReducer from "../core/reducers/AuthOptionsReducer";
import ApplyFieldReducer from "./reducers/ApplyFieldReducer";
import ModalReducer from "../core/reducers/ModalReducer";
import FileReducer from "./reducers/FileReducer";
import PageReducer from "./reducers/PageReducer";
import SummaryReducer from "./reducers/SummaryReduser";
import UpsaleReducer from "./reducers/UpsaleReducer";
import UserReducer from "../core/reducers/UserReducer";
import PaymentReducer from "./reducers/PaymentReducer";
import ErrorBoundary from "../core/components/ErrorBoundary";
import BalanceReducer from "../account/reducers/BalanceReducer";
import SiteReducer from "../core/reducers/SiteReducer";
import AuthTabReducer from "./reducers/AuthTabReducer";
import {siteSetData} from "../core/actions/SiteActions";

const store = configureStore({
    balance: BalanceReducer,
    orderOptions: OrderOptionsReducer,
    authOptions: AuthOptionsReducer,
    applyField: ApplyFieldReducer,
    modal: ModalReducer,
    file: FileReducer,
    page: PageReducer,
    authTab: AuthTabReducer,
    summary: SummaryReducer,
    upsale: UpsaleReducer,
    user: UserReducer,
    payment: PaymentReducer,
    site: SiteReducer,
});

window.rootElement = document.getElementById('form-app');

const dataset = rootElement.dataset;

store.dispatch(siteSetData({
    facebookAppId: dataset.facebookAppId,
    googleAppId: dataset.googleAppId,
    lang: dataset.lang,
    parentSite: dataset.parentSite,
    parentSiteEmail: dataset.parentSiteEmail,
    socialAuthStatus: !!parseInt(dataset.socialAuthStatus),
    socialAuthStatusGoogle: !!parseInt(dataset.socialAuthStatusGoogle),
    recaptchaSiteKey: dataset.recaptchaSiteKey,
}));

render(
    <Provider store={store}>
        <ErrorBoundary>
            <Index />
        </ErrorBoundary>
    </Provider>,
    rootElement,
);
